export {detectOverWidth};

function detectOverWidth(width)
{
    return ($(window).width() >= width);
}